<template>
  <div class="login">
    <img class="login-logo" src="@/assets/images/login/login-logo.png" alt="" />
    <div class="login-box">
      <div class="login-form">
        <!-- <div class="exam-title">{{ appStore.getExamMsg?.name }}</div> -->
        <div class="login-title">考试系统</div>
        <el-form :model="form" ref="formRef" :rules="rules">
          <el-form-item label="" prop="memberName">
            <el-input
              v-model.trim="form.memberName"
              placeholder="请输入考生姓名"
              size="large"
            >
              <template #prefix>
                <img
                  class="input-icon"
                  src="@/assets/images/login/user.png"
                  alt=""
                />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="idCard">
            <el-input
              v-model.trim="form.idCard"
              placeholder="请输入考生身份证号"
              size="large"
            >
              <template #prefix>
                <img
                  class="input-icon"
                  src="@/assets/images/login/id-card.png"
                  alt=""
                /> </template
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="memberCode">
            <el-input
              v-model.trim="form.memberCode"
              placeholder="请输入考生准考证号"
              size="large"
            >
              <template #prefix>
                <img
                  class="input-icon"
                  src="@/assets/images/login/lock.png"
                  alt=""
                /> </template
            ></el-input>
          </el-form-item>
          <el-form-item style="width: 100%">
            <el-button
              type="primary"
              size="large"
              class="confirm-btn"
              @click="submitForm"
              :loading="loading"
              >登 录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, getCurrentInstance } from "vue";
import { useRouter, useRoute } from "vue-router";
const router = useRouter(); // 路由对象
const route = useRoute();
import { login } from "@/api/index.js";
import { useAppStore } from "@/store";
import { ElMessage } from "element-plus";
const appStore = useAppStore();
const { proxy } = getCurrentInstance();
const form = ref({
  // 100003 考试
  // memberName: "洪泽宇",
  // idCard: "232323199610101100",
  // memberCode: "282828282828",
  memberName: "",
  idCard: "",
  memberCode: "",
});
const loading = ref(false);
const rules = {
  memberName: [
    { required: true, message: "请输入考生姓名", trigger: "change" },
  ],
  idCard: [
    { required: true, message: "请输入考生身份证号", trigger: "change" },
  ],
  memberCode: [
    { required: true, message: "请输入考生准考证号", trigger: "change" },
  ],
};
const submitForm = async () => {
  loading.value = true;
  try {
    const validate = await proxy.$refs.formRef.validate();
    if (!validate) {
      loading.value = false;
      return;
    }
    const params = {
      ...form.value,
    };
    const loginRes = await login(params);
    localStorage.setItem("MD5", loginRes.data.md5);
    localStorage.setItem(
      "user_info",
      JSON.stringify({
        ...params,
        examCode: loginRes.data.examCode,
        examType: loginRes.data.examType,
      }),
    );
    appStore.SET_PAPER(loginRes.data.paper);
    if (
      appStore.getServerTime >
      new Date(appStore.getExamPaper?.startTime).getTime()
    ) {
      router.push("/exam");
    } else {
      router.push("/rule");
    }
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  if (localStorage.getItem("MD5") || localStorage.getItem("user_info")) {
    router.push("/rule");
    return;
  }

  // fetch("/node/nodeCheck")
  //   .then((res) => res.json())
  //   .then((res) => console.log("ok:", res))
  //   .catch((err) => console.error("err:", err));
});
</script>
<style scoped lang="less">
.login {
  height: 100%;
  background: #f5f7fa;
  background-image: url("@/assets/images/login/login-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .login-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
  .login-logo {
    width: 700px;
    margin-right: 100px;
  }
  .login-form {
    padding: 50px;
    border-radius: 1rem;
    width: 320px;
    background-color: #fff;
    box-shadow: 0 0 20px 2px #bfd2ef66;
  }
  .exam-title {
    text-align: center;
    color: #1c68ff;
    font-weight: 600;
    font-size: 28px;
    line-height: 45px;
  }

  .login-title {
    text-align: center;
    color: #1c68ff;
    font-weight: 600;
    font-size: 28px;
    line-height: 45px;
    // text-align: center;
    margin-bottom: 32px;
    // font-size: 28px;
    // line-height: 45px;
    // font-weight: 500;
    // color: #ff9e44;
  }
  :deep(.el-input) {
    width: 100%;
  }
  :deep(.input-icon) {
    width: 28px;
    height: 28px;
  }
  :deep(.el-input__wrapper) {
    background-color: #f7faff !important;
    box-shadow: none;
  }
  .confirm-btn {
    width: 100%;
    background-color: #1c68ffff;
    height: 46px;
  }
}
</style>
